import { render, staticRenderFns } from "./CopyOrder.vue?vue&type=template&id=71c434aa"
import script from "./CopyOrder.vue?vue&type=script&lang=js"
export * from "./CopyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports